import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const LegalPage = ({ eyebrow, title, intro, children, testid }) => {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-obsidian text-white" data-testid={testid}>
      <Header onOrganizer={() => nav("/contact")} />
      <main className="pt-16">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">{eyebrow}</p>
            <h1 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
            {intro && <p className="mt-4 text-slate-400">{intro}</p>}
            <div className="mt-10 space-y-8">{children}</div>
          </motion.div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-white">{title}</h2>
    <div className="mt-2 space-y-2 text-sm leading-relaxed text-slate-400">{children}</div>
  </section>
);
